module.exports = __webpack_public_path__ + "img/number3.f10751b8.svg";